import ReactTruncateMarkup, { TruncateProps } from 'react-truncate-markup';

export const TruncateMarkup = ({ children, ...rest }: TruncateProps) => {
  return <ReactTruncateMarkup {...rest}>{children}</ReactTruncateMarkup>;
};
